import axiosInstance from "./index.services";

export async function MicroSoftTeamsResendEmail({id} : {id: number | string}){
  const response = await axiosInstance.post(`/teams-license/${id}/resend-email/ `, {
    headers: { "Content-Type": "application/json" },
  });
  return response;
}